import React from 'react';
import { IconSvgProps } from '@models/common';

const Layers: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.66602 9.99997L9.70121 14.0176C9.81052 14.0722 9.86518 14.0996 9.92252 14.1103C9.97329 14.1198 10.0254 14.1198 10.0762 14.1103C10.1335 14.0996 10.1882 14.0722 10.2975 14.0176L18.3327 9.99997M1.66602 14.1666L9.70121 18.1842C9.81052 18.2389 9.86518 18.2662 9.92252 18.277C9.97329 18.2865 10.0254 18.2865 10.0762 18.277C10.1335 18.2662 10.1882 18.2389 10.2975 18.1842L18.3327 14.1666M1.66602 5.83331L9.70121 1.81571C9.81052 1.76105 9.86518 1.73372 9.92252 1.72297C9.97329 1.71344 10.0254 1.71344 10.0762 1.72297C10.1335 1.73372 10.1882 1.76105 10.2975 1.81571L18.3327 5.83331L10.2975 9.8509C10.1882 9.90556 10.1335 9.93289 10.0762 9.94365C10.0254 9.95317 9.97329 9.95317 9.92252 9.94365C9.86518 9.93289 9.81052 9.90556 9.70121 9.8509L1.66602 5.83331Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Layers;
